import { useEffect } from 'react';
import { useStatusBuilderConfiguration } from '../../../shared/stores/useConfigurationStore';
import type { SelectedNode } from '../lib/selectionTreeModel';
import { useProjectPhaseStatusCategories } from './useProjectPhaseStatusCategories';

interface UseStatusBuilderNavigationArgs {
  selectedNode: SelectedNode;
  onNodeSelect: (type: string, name?: string) => void;
}

export function useStatusBuilderNavigation({
  selectedNode,
  onNodeSelect,
}: UseStatusBuilderNavigationArgs) {
  const { categories } = useStatusBuilderConfiguration();
  const { isLoading, error } = useProjectPhaseStatusCategories();

  useEffect(() => {
    if (
      isLoading
      || selectedNode.type !== 'statusCategory'
      || categories.length === 0
      || categories.some((category) => category.id === selectedNode.name)
    ) {
      return;
    }

    onNodeSelect('statusCategory', categories[0].id);
  }, [categories, isLoading, onNodeSelect, selectedNode.name, selectedNode.type]);

  return { categories, isLoading, error };
}
